import React from 'react';
import { useTranslation } from 'react-i18next';
import './dashboard.scss';

interface DashboardStatsProps {
  totalInvoices: number;
  totalAmount: number;
  totalOrders: number;
  totalShipForMe: number;
  totalRevenue: number;
  averageOrderValue: number;
  iqdRate: number | null;
  iqdRateDate: string | null;
}

export const DashboardStats: React.FC<DashboardStatsProps> = ({
  totalInvoices,
  totalAmount,
  totalOrders,
  totalShipForMe,
  totalRevenue,
  averageOrderValue,
  iqdRate,
  iqdRateDate,
}) => {
  const { t } = useTranslation();

  const iqdValue = iqdRate != null
    ? `${iqdRate.toLocaleString()} IQD`
    : t('dashboard:iqdExchangeRateNotAvailable');

  const stats = [
    {
      title: t('dashboard:totalInvoices'),
      value: totalInvoices,
      icon: '📄',
      color: 'blue',
    },
    // {
    //   title: t('dashboard:totalAmount'),
    //   value: `$${totalAmount.toFixed(2)}`,
    //   icon: '💰',
    //   color: 'green',
    // },
    {
      title: t('dashboard:totalOrders'),
      value: totalOrders,
      icon: '📦',
      color: 'orange',
    },
    {
      title: t('dashboard:totalShipForMe'),
      value: totalShipForMe,
      icon: '🚚',
      color: 'purple',
    },
    // {
    //   title: t('dashboard:totalRevenue'),
    //   value: `$${totalRevenue.toFixed(2)}`,
    //   icon: '📈',
    //   color: 'red',
    // },
    {
      title: t('dashboard:averageOrderValue'),
      value: `$${averageOrderValue.toFixed(2)}`,
      icon: '📊',
      color: 'indigo',
    },
  ];

  return (
    <div className="dashboard-stats">
      {stats.map((stat, index) => (
        <div key={index} className={`stat-card stat-card--${stat.color}`}>
          <div className="stat-icon">{stat.icon}</div>
          <div className="stat-content">
            <h4 className="stat-title">{stat.title}</h4>
            <p className="stat-value">{stat.value}</p>
          </div>
        </div>
      ))}

      {/* IQD Exchange Rate card */}
      <div className="stat-card stat-card--teal">
        <div className="stat-icon">💱</div>
        <div className="stat-content">
          <h4 className="stat-title">{t('dashboard:iqdExchangeRate')}</h4>
          <p className="stat-value">{iqdValue}</p>
          {iqdRateDate && (
            <p className="stat-subtitle">
              {t('dashboard:iqdExchangeRateDate')}: {new Date(iqdRateDate).toLocaleString()}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

